export default __webpack_public_path__ + "d482ae8d3f87382da612e89074008e06.svg";